document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('[data-video-playlist-id]');
  if (!sections.length) return;

  sections.forEach(function (section) {
    initVideoPlaylist(section);
  });

  function initVideoPlaylist(section) {
    var mainFrame = section.querySelector('.js-video-main');
    var titleEl = section.querySelector('.js-video-title');
    var descEl = section.querySelector('.js-video-description');

    var list = section.querySelector('.js-video-list');
    var items = list
      ? Array.prototype.slice.call(list.querySelectorAll('.c-video-playlist__item'))
      : [];

    var toggleBtn = section.querySelector('.js-video-toggle');

    var rail = section.querySelector('.c-video-playlist__rail');
    var dot = section.querySelector('.c-video-playlist__rail-dot');

    if (!mainFrame || !list || !items.length || !rail || !dot) return;

    var currentIndex = 0;
    var resizeRAF = null;

    items.forEach(function (item, idx) {
      if (item.classList.contains('is-active')) currentIndex = idx;
    });

    function clampIndex(index) {
      if (index < 0) return 0;
      if (index > items.length - 1) return items.length - 1;
      return index;
    }

    function setRailHeightToList() {
      var listRect = list.getBoundingClientRect();
      var h = listRect.height || 0;
      if (h > 0) {
        rail.style.height = h + 'px';
      }
    }

    function moveDotToItem(index) {
      index = clampIndex(index);
      currentIndex = index;

      var item = items[index];
      if (!item) return;

      var itemRect = item.getBoundingClientRect();
      var railRect = rail.getBoundingClientRect();

      var itemCenter = itemRect.top + itemRect.height / 2 - railRect.top;
      dot.style.top = itemCenter + 'px';
    }

    function syncRailAndDot() {
      setRailHeightToList();
      moveDotToItem(currentIndex);
    }

    function syncRailAndDotNextFrame() {
      requestAnimationFrame(function () {
        syncRailAndDot();
      });
    }

    // Inicial
    syncRailAndDotNextFrame();

    // Clique nos itens
    items.forEach(function (item, index) {
      item.addEventListener('click', function () {
        var src = item.getAttribute('data-video-src');
        var title = item.getAttribute('data-video-title') || '';
        var description = item.getAttribute('data-video-description') || '';

        if (src) mainFrame.setAttribute('src', src);
        if (titleEl) titleEl.textContent = title;
        if (descEl) descEl.textContent = description;

        items.forEach(function (i) {
          i.classList.remove('is-active');
        });
        item.classList.add('is-active');

        currentIndex = index;

        // Figma mode: rail acompanha lista; dot cola no item ativo
        syncRailAndDotNextFrame();
      });
    });

    // Ver mais / ver menos
    if (toggleBtn && items.length > 4) {
      toggleBtn.addEventListener('click', function () {
        var expanded = list.classList.toggle('is-expanded');

        var labelMore = toggleBtn.getAttribute('data-label-more') || 'ver mais';
        var labelLess = toggleBtn.getAttribute('data-label-less') || 'ver menos';
        toggleBtn.textContent = expanded ? labelLess : labelMore;

        syncRailAndDotNextFrame();
      });
    }

    // Resize (debounced com RAF)
    window.addEventListener('resize', function () {
      if (resizeRAF) cancelAnimationFrame(resizeRAF);
      resizeRAF = requestAnimationFrame(function () {
        syncRailAndDot();
        resizeRAF = null;
      });
    });

    // Se thumbs carregarem depois
    var imgs = list.querySelectorAll('img');
    if (imgs.length) {
      imgs.forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', function () {
          syncRailAndDotNextFrame();
        });
      });
    }
  }
});
